import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove"}/>
}
